import { EmptyView } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { SpotUpload } from '../../../../../../assets/images'
import { useDmsUserRole } from '../../../../hooks/useDmsUserRole'
import * as Styled from './styles'

export const FolderContentEmptyState = (): ReactElement => {
  const { t } = useTranslation()
  const { isCpaExpertMode } = useDmsUserRole()

  const tDescription = isCpaExpertMode
    ? t('documents.folder_content.empty_state.description_cpa')
    : t('documents.folder_content.empty_state.description_bo_without_cpa')

  return (
    <Styled.CenteredWrapper>
      <EmptyView
        illustration={<SpotUpload />}
        tTitle={t('documents.folder_content.empty_state.title')}
        tDescription={tDescription}
      />
    </Styled.CenteredWrapper>
  )
}
